// extracted by mini-css-extract-plugin
export default {"root":"BlueBillyWigVideo_root__Ywr0t","bbw":"BlueBillyWigVideo_bbw__NxHcH"};